import {
  SESSION_BROADCAST_CHANNEL,
  SESSION_BROADCAST_TYPE_FORCE_LOGOUT,
} from "./session.constants";
import {
  clearClientAuthStorage,
  setSessionEnded,
} from "./sessionEnded";
import { captureReturnUrl } from "./sessionReturnUrl";

const TAB_ID_KEY = "ctpo-tab-id";

export function getSessionTabId() {
  try {
    let id = sessionStorage.getItem(TAB_ID_KEY);
    if (!id) {
      id = `ctpo-tab-${Date.now()}-${Math.random().toString(36).slice(2, 11)}`;
      sessionStorage.setItem(TAB_ID_KEY, id);
    }
    return id;
  } catch {
    return `ctpo-tab-fallback-${Math.random().toString(36).slice(2)}`;
  }
}

export function sessionLogout(
  instance,
  account,
  { reason = "manual", broadcast = false } = {},
) {
  captureReturnUrl();
  setSessionEnded();

  if (broadcast && typeof BroadcastChannel !== "undefined") {
    try {
      const ch = new BroadcastChannel(SESSION_BROADCAST_CHANNEL);
      ch.postMessage({
        type: SESSION_BROADCAST_TYPE_FORCE_LOGOUT,
        reason,
        tabId: getSessionTabId(),
      });
      ch.close();
    } catch (e) {
      console.debug("sessionLogout broadcast failed", e);
    }
  }

  try {
    instance?.clearCache?.();
  } catch (e) {
    console.debug("sessionLogout clearCache failed", e);
  }

  clearClientAuthStorage();
  window.location.replace(`${window.location.origin}/goodbye`);
}
